import { dictionaryWords } from './dictionaryData';

let dictionary: Set<string> | null = null;

export const loadDictionary = async (): Promise<void> => {
  if (dictionary) return; // Already loaded
  
  try {
    // No fetch needed, use the imported data
    const words = dictionaryWords.map(word => word.trim().toUpperCase());
    dictionary = new Set(words);
    console.log(`Dictionary loaded with ${dictionary.size} words`);
  } catch (error) {
    console.error('Error loading dictionary:', error);
    dictionary = new Set();
  }
};

export const isValidWord = (word: string): boolean => {
  if (!dictionary) {
    console.warn('Dictionary not loaded yet');
    return true; // Allow all words if dictionary isn't loaded
  }
  
  // If dictionary is empty (failed to load), accept all words
  if (dictionary.size === 0) {
    return true;
  }
  
  return dictionary.has(word.trim().toUpperCase());
}; 